import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { UserRoles, UserRole } from "./types";

const fetchUserRoles = async (): Promise<UserRoles> => {
  try {
    const rolesDocRef = doc(db, "userRoles", "roles");
    const rolesDocSnapshot = await getDoc(rolesDocRef);

    if (rolesDocSnapshot.exists()) {
      const data = rolesDocSnapshot.data();
      if (!data) return {} as UserRoles;

      // Normalize roles: handle both string format and object format {role, email, canComment}
      const normalizedRoles: UserRoles = {};
      Object.entries(data).forEach(([uid, value]) => {
        if (!value) return;
        if (typeof value === "string") {
          // Already in string format
          normalizedRoles[uid] = value as UserRole;
        } else if (typeof value === "object" && "role" in value) {
          // Object format: preserve the full object including canComment
          normalizedRoles[uid] = value as { role: UserRole; email?: string; canComment?: boolean };
        }
      });

      return normalizedRoles;
    } else {
      // Document doesn't exist, return empty roles
      return {} as UserRoles;
    }
  } catch (error) {
    console.error("Error fetching roles:", error);
    // Return empty roles instead of throwing to prevent app crash
    return {} as UserRoles;
  }
};

export default fetchUserRoles;
